import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { MarketingLayout } from '@/components/layout/marketing-layout';

const HomePage = lazy(() => import('@/pages/home'));
const ServicesPage = lazy(() => import('@/pages/services'));
const PhilosophyPage = lazy(() => import('@/pages/philosophy'));
const ProcessPage = lazy(() => import('@/pages/process'));
const InsightsPage = lazy(() => import('@/pages/insights'));
const ContactPage = lazy(() => import('@/pages/contact'));
const PrivacyPage = lazy(() => import('@/pages/privacy'));
const NotFoundPage = lazy(() => import('@/pages/not-found'));
const ErrorPage = lazy(() => import('@/pages/error'));

function SuspenseRoute({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={null}>{children}</Suspense>;
}

export const router = createBrowserRouter([
  {
    element: <MarketingLayout />,
    children: [
      // Pathless route: errorElement here catches errors from any descendant page
      // and renders inside MarketingLayout's <Outlet />, keeping header/footer.
      {
        errorElement: (
          <SuspenseRoute>
            <ErrorPage />
          </SuspenseRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <SuspenseRoute>
                <HomePage />
              </SuspenseRoute>
            ),
          },
          {
            path: '/services',
            element: (
              <SuspenseRoute>
                <ServicesPage />
              </SuspenseRoute>
            ),
          },
          {
            path: '/philosophy',
            element: (
              <SuspenseRoute>
                <PhilosophyPage />
              </SuspenseRoute>
            ),
          },
          {
            path: '/process',
            element: (
              <SuspenseRoute>
                <ProcessPage />
              </SuspenseRoute>
            ),
          },
          {
            path: '/insights',
            element: (
              <SuspenseRoute>
                <InsightsPage />
              </SuspenseRoute>
            ),
          },
          {
            path: '/contact',
            element: (
              <SuspenseRoute>
                <ContactPage />
              </SuspenseRoute>
            ),
          },
          {
            path: '/privacy',
            element: (
              <SuspenseRoute>
                <PrivacyPage />
              </SuspenseRoute>
            ),
          },
          // Catches anything else and shows the in-layout 404 (header + footer preserved).
          {
            path: '*',
            element: (
              <SuspenseRoute>
                <NotFoundPage />
              </SuspenseRoute>
            ),
          },
        ],
      },
    ],
  },
]);
